import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import Divider from "@material-ui/core/Divider";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import {
  CheckBoxOutlineBlank,
  Place,
  NavigateBefore,
  NavigateNext,
  EmojiPeople,
  Business,
  CheckBox,
  Pageview,
  LibraryAddCheck,
  GpsFixed,
} from "@material-ui/icons";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import deLocale from "date-fns/locale/es";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Slide from "@material-ui/core/Slide";
import StepConnector from "@material-ui/core/StepConnector";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Tooltip from "@material-ui/core/Tooltip";
import Skeleton from "@material-ui/lab/Skeleton";

// SELECT
import LoadCiudades from "components/services/LoadCiudades_conecta2";
import LoadRecyclerType from "components/services/LoadRecyclerType";
import LoadGender from "components/services/LoadGender";

import MapDraggableMarker from "views/Maps/MapDraggableMarker";
import SuccessfulMessage from "views/dialog/SuccessfulMessageForm";
import WasteResourcesData from "views/dialog/WasteResourcesData";

import {
  cardStyle,
  ColorlibConnectorCss,
  HtmlTooltipCss,
} from "assets/jss/material-dashboard-react/components/cardStyle";

const useStyles = makeStyles(cardStyle);

const ColorlibConnector = withStyles(ColorlibConnectorCss)(StepConnector);

const HtmlTooltip = withStyles(HtmlTooltipCss)(Tooltip);

export default function Form2() {
  const classes = useStyles();

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [loader, setloader] = useState(true);
  const [mensaje_success, setMensaje_success] = useState("");

  const [catSelectWaste, setCatSelectWaste] = useState(false);
  const [catSelectValueWaste, setCatSelectValueWaste] = useState("");
  const [dataCatWaste, setdataCatWaste] = useState("");

  const [values, setValues] = useState({
    nameContact: "",
    lastNameContact: "",
    documentContact: "",
    email: "",
    descriptionRecycler: "",
    nameRecycler: "",
    phoneContact: "",
    cityRecycler: "",
    cityRecyclerData: "",
    latitude: -0.18093079060265435,
    longitude: -78.46778869628906,
    actorType: "",
    actorTypeData: "",
    dateStartRecycler: null,
    addressRecycler: "",
    womanNumber: "",
    menNumber: "",
    genderContact: "",
    genderContactData: "",
    /*  RESIDUOS ORGANICOS*/
    organicWaste: [],
    organicWasteDataN: [],
    organicWasteDataNViews: [],
    /* ALERT ERROR */
    errorFieldCity: false,
    errorGenderContact: false,
    errorFieldactorType: false,
    errorFieldWomanNumber: false,
    errorFieldMenNumber: false,
    errorDateStartRecycler: false,
    errorFieldnameContact: false,
    errorFieldlastNameContact: false,
    errorFielddocumentContact: false,
    errorFieldEmail: false,
    errorFieldphoneContact: false,
    errorFieldnameRecycler: false,
    errorFielddescriptionRecycler: false,
    errorFieldaddressRecycler: false,
    /*  ALERT RECUROS RESIDUALES */
    errorOrganicWasteN: false,
  });

  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const [dataLtLgCiudad, setDataLtLgCiudad] = useState({
    lt: -0.18093079060265435,
    lg: -78.46778869628906,
  });
  const [openAlertsuccess, setOpenAlertsuccess] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [mensaje_error, setMensaje_error] = useState("");
  const [openBackdrop, setoOpenBackdrop] = useState(false);

  useEffect(() => {
    const dataCat = {
      catalogs: [
        {
          detailName: "catOrganicWaste",
          codeExclusion: "0",
        },
      ],
    };

    axios
      .post(`${urlServices}catalogsDetails/getMultiplesCatalogs`, dataCat, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setValues({
              ...values,
              /* RECURSOS RESIDUALES */
              organicWaste: response.data.catalogs.catOrganicWaste,
            });
            setloader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }, [urlServices, keyAplication]);

  const handleNext = () => {
    if (activeStep === 0) {
      // STEP 1 PERSONA DE CONTACTO

      if (values.nameContact.length === 0) {
        setValues({
          ...values,
          errorFieldnameContact: true,
        });
        setMensaje_error('El campo "Nombre" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.lastNameContact.length === 0) {
        setValues({
          ...values,
          errorFieldlastNameContact: true,
        });
        setMensaje_error('El campo "Apellidos" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.documentContact.length === 0) {
        setValues({
          ...values,
          errorFielddocumentContact: true,
        });
        setMensaje_error('El campo "Cédula" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.email.length === 0) {
        setValues({
          ...values,
          errorFieldEmail: true,
        });
        setMensaje_error('El campo "Correo Electrónico" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (!values.email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        setValues({
          ...values,
          errorFieldEmail: true,
        });
        setMensaje_error('El campo "Correo Electrónico" no es válido!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.phoneContact.length === 0) {
        setValues({
          ...values,
          errorFieldphoneContact: true,
        });
        setMensaje_error('El campo "Teléfono" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.genderContact.length === 0) {
        setValues({
          ...values,
          errorGenderContact: true,
        });
        setMensaje_error('El campo "Género" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else if (activeStep === 1) {
      // STEP 2 EMPRESA

      if (values.nameRecycler.length === 0) {
        setValues({
          ...values,
          errorFieldnameRecycler: true,
        });
        setMensaje_error('El campo "Nombre del reciclador" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.descriptionRecycler.length === 0) {
        setValues({
          ...values,
          errorFielddescriptionRecycler: true,
        });
        setMensaje_error('El campo "Descripción" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.cityRecycler === "") {
        setValues({
          ...values,
          errorFieldCity: true,
        });
        setMensaje_error('Seleccione una opción en "Ciudades"');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.addressRecycler.length === 0) {
        setValues({
          ...values,
          errorFieldaddressRecycler: true,
        });
        setMensaje_error('El campo "Dirección" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.womanNumber.length === 0) {
        setValues({
          ...values,
          errorFieldWomanNumber: true,
        });
        setMensaje_error("Número de mujeres es obligatorio!");
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.menNumber.length === 0) {
        setValues({
          ...values,
          errorFieldMenNumber: true,
        });
        setMensaje_error("Número de hombres es obligatorio!");
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.actorType === "") {
        setValues({
          ...values,
          errorFieldactorType: true,
        });
        setMensaje_error('Seleccione una opción en "Tipo de actor"');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else if (values.dateStartRecycler === null) {
        setValues({
          ...values,
          errorDateStartRecycler: true,
        });
        setMensaje_error('El campo "Fecha de inicio del proyecto en Ecuador" es obligatorio!');
        setOpenAlert(true);
        setoOpenBackdrop(false);
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } else if (activeStep === 2) {
      // STEP 3 EMPRESA YO TENGO
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (activeStep === 3) {
      // STEP 4 EMPRESA YO NECESITO
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (activeStep === 4) {
      // STEP 5 YO TENGO RECURSOS RESIDUALES
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleReset = () => {
    setActiveStep(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorFieldnameRecycler: false,
      errorFieldMenNumber: false,
      errorFieldnameContact: false,
      errorFieldlastNameContact: false,
      errorFielddocumentContact: false,
      errorFieldEmail: false,
      errorFieldphoneContact: false,
      errorFielddescriptionRecycler: false,
      errorFieldaddressRecycler: false,
      errorFieldWomanNumber: false,
    });
  };

  const getResponseActorType = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        actorType: pro.code,
        actorTypeData: pro,
        errorFieldactorType: false,
      });
    } else {
      setValues({
        ...values,
        actorType: "",
        actorTypeData: pro,
      });
    }
  };

  const getResponseGender = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        genderContact: pro.code,
        genderContactData: pro,
        errorGenderContact: false,
      });
    } else {
      setValues({
        ...values,
        genderContact: "",
        genderContactData: pro,
      });
    }
  };

  const getResponseCityRecycler = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        cityRecycler: pro.idCiudad,
        cityRecyclerData: pro,
        errorFieldCity: false,
      });
      setDataLtLgCiudad({ lt: pro.latitud, lg: pro.longitud });
    } else {
      setValues({
        ...values,
        cityRecycler: "",
        cityRecyclerData: pro,
      });
      setDataLtLgCiudad({ lt: -0.18093079060265435, lg: -78.46778869628906 });
    }
  };

  const handleChangeDateStartRecycler = (date) => {
    setValues({
      ...values,
      dateStartRecycler: date,
      errorDateStartRecycler: false,
    });
  };

  const getResponselt = (latitude) => {
    setValues({ ...values, latitude: latitude });
  };

  const getResponselng = (longitude) => {
    setValues({ ...values, longitude: longitude });
  };

  const handleClose = (event, reason) => {
    setOpenAlert(false);
    setOpenAlertsuccess(false);
  };

  const callbackWasteResourcesData = (data) => {
    if (data.save !== 0) {
      let arr = values[catSelectValueWaste.cat + "Views"];

      arr.push({
        detailName: data.detailName,
        code: data.code,
        cat_id: data.cat_id,
        wasteState: data.wasteState,
        wasteStateName: data.wasteStateName,
        estimatedAmount: data.estimatedAmount,
        estimatedAmountName: data.estimatedAmountName,
        weightKg: data.weightKg,
        weightKgName: data.weightKgName,
        transports: data.transports,
        transportsName: data.transportsName,
        transactionType: data.transactionType,
        wasteUsage: data.wasteUsage,
        wasteUsageName: data.wasteUsageName,
      });

      setValues({ ...values, [catSelectValueWaste.cat + "Views"]: arr });
    } else {
      catSelectValueWaste.value.map((items, i) => {
        if (items.catalog_id === data.cat_id) {
          if (items.code === data.code) {
            catSelectValueWaste.value.splice(i, 1);
          }
        }
      });

      setValues({
        ...values,
        [catSelectValueWaste.cat]: catSelectValueWaste.value,
      });
    }

    setCatSelectWaste(false);
  };

  const handleCloseSuccess = (event, reason) => {
    setOpenAlert(false);
    setOpenAlertsuccess(false);
    setActiveStep(0);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* RECUROS RESIDUALES */

  const changeOrganicWaste = (e, data) => {
    var datos = [],
      output = "";

    if (data.length >= values.organicWasteDataN.length) {
      for (var i = 0; i < data.length; i++) {
        if (values.organicWasteDataN.length > 0) {
          for (var i1 = 0; i1 < values.organicWasteDataN.length; i1++) {
            if (values.organicWasteDataN[i1] !== data[i]) {
              datos = [
                {
                  code: data[i].code,
                  id: data[i].id,
                  detailName: data[i].detailName,
                  cat_id: data[i].catalog_id,
                },
              ];
            }
          }
        } else {
          datos = [
            {
              code: data[i].code,
              id: data[i].id,
              detailName: data[i].detailName,
              cat_id: data[i].catalog_id,
            },
          ];
        }
      }
      setValues({
        ...values,
        organicWasteDataN: data,
        errorOrganicWasteN: false,
      });
      setCatSelectValueWaste({ value: data, cat: "organicWasteDataN" });
      setCatSelectWaste(true);
      setdataCatWaste(datos);
    } else {
      output = deleteCatViewsWaste(data, values.organicWasteDataNViews);

      setValues({
        ...values,
        organicWasteDataN: data,
        organicWasteDataNViews: data.length !== 0 ? output : data,
      });
    }
  };

  const deleteCatViews = (data, cat) => {
    for (var i = 0; i < cat.length; i++) {
      var isAGoodUser = false;
      for (var y = 0; y < data.length; y++) {
        if (cat[i].detailName === data[y].detailName) {
          isAGoodUser = true;
          break;
        }
      }
      if (!isAGoodUser) {
        cat.splice(i, 1);
      }
    }

    return cat;
  };

  const deleteCatViewsWaste = (data, cat) => {
    for (var i = 0; i < cat.length; i++) {
      var isAGoodUser = false;
      for (var y = 0; y < data.length; y++) {
        if (cat[i].detailName === data[y].detailName) {
          isAGoodUser = true;
          break;
        }
      }
      if (!isAGoodUser) {
        cat.splice(i, 1);
      }
    }

    return cat;
  };

  const textCatSelectWaste = (items) => {
    let output = [],
      numRows = items.transactionType.length;

    items.transactionType.map((items, i) => {
      output.push(items.detailName);

      if (i < numRows - 1) {
        output.push(", ");
      } else {
        output.push(".");
      }
      return output;
    });

    return (
      <Fragment>
        <p>
          <b>ESTADO:</b> {items.wasteStateName}
          <br></br> <br></br>
          <b>PESO EN KILOS:</b> {items.weightKgName}
          <br></br> <br></br>
          <b>VALOR ESTIMADO $:</b> {items.estimatedAmountName}
          <br></br> <br></br>
          <b>TIPO DE ACUERDO:</b> {output}
          <br></br> <br></br>
          <b>TRANSPORTE:</b> {items.transportsName}
          <br></br> <br></br>
          <b>USO DE RESIDUO:</b> {items.wasteUsageName}
        </p>
      </Fragment>
    );
  };

  const includeHasArray = (views) => {
    let output = [];

    views.map((items, i) => {
      if (items.view.length > 0) {
        items.view.map((items2, i) => {
          output.push({
            need_id: items2.code,
            catalog_id: items2.cat_id,
            another: "0",
            description:
              items2.description === undefined ? null : items2.description,
            estimated_mount_id: items2.estimatedAmount,
            transaction_type: JSON.stringify(items2.transactionType),
            waste_state_id:
              items2.wasteState === undefined ? null : items2.wasteState,
            weight_kg_id:
              items2.weightKg === undefined ? null : items2.weightKg,
            transport_id:
              items2.transports === undefined ? null : items2.transports,
            waste_usage_id:
              items2.wasteUsage === undefined ? null : items2.wasteUsage,
            solution_type_id: null,
          });
        });
      }
    });
    return output;
  };

  const submitForm = (e) => {
    e.preventDefault();

    setOpenAlertsuccess(false);

    if (
      values.latitude === -0.18093079060265435 &&
      values.longitude === -78.46778869628906
    ) {
      setMensaje_error(
        "Por favor, arrastre el puntero rojo en el mapa para su ubicación!"
      );
      setOpenAlert(true);
      setoOpenBackdrop(false);
    } else {
      setoOpenBackdrop(true);

      let arrayNeed = [{ view: values.organicWasteDataNViews }];

      let need = includeHasArray(arrayNeed);

      const dataValues = {
        name: values.nameContact,
        last_name: values.lastNameContact,
        document_id: values.documentContact,
        stakeholder_name: values.nameRecycler,
        ruc: "0",
        email: values.email.toLowerCase(),
        phone: values.phoneContact,
        gender_id: values.genderContact,
        description: values.descriptionRecycler,
        started_at: format(values.dateStartRecycler, "yyyy-MM-dd"),
        address: values.addressRecycler,
        lat: values.latitude,
        lon: values.longitude,
        city_id: values.cityRecycler,
        city_another: "0",
        actor_type_id: null,
        recycler_type_id: values.actorType,
        headquarters: null,
        sector_id: null,
        solution_id: null,
        solution_another: "0",
        working_men: values.menNumber,
        working_women: values.womanNumber,
        project_name: null,
        education_center: null,
        profile_id: 3,
        have: [],
        need: need,
      };

      axios
        .post(`${urlServices}stakeholders`, dataValues, {
          headers: {
            application: keyAplication,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setValues({
              ...values,
              nameContact: "",
              lastNameContact: "",
              documentContact: "",
              email: "",
              descriptionRecycler: "",
              nameRecycler: "",
              phoneContact: "",
              cityRecycler: "",
              cityRecyclerData: "",
              latitude: -0.18093079060265435,
              longitude: -78.46778869628906,
              actorType: "",
              actorTypeData: "",
              dateStartRecycler: null,
              addressRecycler: "",
              womanNumber: "",
              menNumber: "",
              genderContact: "",
              genderContactData: "",
              organicWasteDataN: [],
              organicWasteDataNViews: [],
            });

            setOpenAlertsuccess(true);
            setMensaje_success(
              "Bienvenido(a) a conecta2, se ha enviado un correo electrónico."
            );
            setoOpenBackdrop(false);
          }
        })
        .catch((e) => {
          if (e.response.status === 402) {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            setoOpenBackdrop(false);
          } else {
            setMensaje_error("Error al registrar los datos");
            setOpenAlert(true);
            console.log(e);
            setoOpenBackdrop(false);
          }
        });
    }
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  return (
    <Fragment>
      <div className={classes.titleCard}>
        REGISTRO PARA RECICLADORES DE RESIDUOS SÓLIDOS
      </div>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>
              <span style={{ fontSize: 12 }}>{label}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Grid
              container
              spacing={3}
              style={{
                paddingTop: "2%",
                paddingRight: "3%",
                paddingLeft: "3%",
              }}
            >
              <Grid item xs={12} sm={12} style={{ marginTop: "5%" }}>
                <div className={classes.titleCardSub2}>
                  <Place className={classes.iconSubTitle} />
                  UBICACIÓN DEL PROYECTO
                </div>
              </Grid>

              <Grid item xs={12} md={12} className={classes.mapStyle}>
                <FormLabel component="legend">
                  <div className={classes.fontParagraph}>
                    <GpsFixed /> Habilita la ubicación de tu navegador.
                    <br></br>
                    Por favor, seleccione el puntero rojo y arrastre hasta la
                    ubicación del proyecto.
                  </div>
                </FormLabel>

                <MapDraggableMarker
                  callbacklt={getResponselt}
                  callbacklng={getResponselng}
                  dataltlg={dataLtLgCiudad}
                />
              </Grid>
              <Grid item xs={12} sm={12} style={{ margin: "90px 0" }}>
                <center>
                  <Button
                    startIcon={<NavigateBefore />}
                    onClick={handleReset}
                    className={classes.backButton}
                  >
                    Volver
                  </Button>

                  <Button onClick={submitForm} className={classes.buttonSubmit}>
                    Registrar
                  </Button>
                </center>
              </Grid>
            </Grid>
          </div>
        ) : (
          <div>
            <Typography className={classes.instructions}>
              {getStepContent(
                activeStep,
                values,
                handleChange,
                getResponseCityRecycler,
                getResponseActorType,
                handleChangeDateStartRecycler,
                icon,
                checkedIcon,
                classes,
                loader,
                getResponseGender,
                textCatSelectWaste,
                changeOrganicWaste
              )}
            </Typography>
            <div>
              <center>
                <div style={{ margin: "10% 0" }}>
                  {activeStep !== 0 ? (
                    <Button
                      onClick={handleBack}
                      className={classes.backButton}
                      startIcon={<NavigateBefore />}
                    >
                      Regresar
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    className={classes.buttonSubmit}
                    endIcon={<NavigateNext />}
                    onClick={handleNext}
                  >
                    {activeStep === steps.length - 1
                      ? "Finalizar"
                      : "Siguiente"}
                  </Button>
                </div>
              </center>
            </div>
          </div>
        )}
      </div>
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openAlert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity="error"
            elevation={6}
            variant="filled"
          >
            {mensaje_error}
          </Alert>
        </Slide>
      </Snackbar>
      {openAlertsuccess ? (
        <SuccessfulMessage
          callbackFalse={handleCloseSuccess}
          callbackTrue={openAlertsuccess}
          mensaje_success={mensaje_success}
        />
      ) : (
        ""
      )}

      {catSelectWaste ? (
        <WasteResourcesData
          callback={callbackWasteResourcesData}
          open={catSelectWaste}
          data={dataCatWaste}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
}

function getSteps() {
  return [
    "Contacto",
    "Reciclador / Organización / Empresa",
    "Recursos residuales",
  ];
}

function getStepContent(
  stepIndex,
  values,
  handleChange,
  getResponseCityRecycler,
  getResponseActorType,
  handleChangeDateStartRecycler,
  icon,
  checkedIcon,
  classes,
  loader,
  getResponseGender,
  textCatSelectWaste,
  changeOrganicWaste
) {
  switch (stepIndex) {
    case 0:
      return step1Form(values, handleChange, classes, getResponseGender);
    case 1:
      return step2Form(
        values,
        handleChange,
        getResponseCityRecycler,
        getResponseActorType,
        handleChangeDateStartRecycler,
        classes
      );
    case 2:
      return step3Form(
        values,
        icon,
        checkedIcon,
        classes,
        loader,
        textCatSelectWaste,
        changeOrganicWaste
      );
    default:
      return "Unknown stepIndex";
  }
}

function step1Form(values, handleChange, classes, getResponseGender) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <EmojiPeople className={classes.iconSubTitle} />
            PERSONA DE CONTACTO
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="nameContact"
            value={values.nameContact}
            error={values.errorFieldnameContact}
            onChange={handleChange("nameContact")}
            fullWidth
            required
            inputProps={{ maxLength: 100 }}
            autoComplete="off"
            label="Nombre"
            //helperText="Error"
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="lastNameContact"
            value={values.lastNameContact}
            error={values.errorFieldlastNameContact}
            onChange={handleChange("lastNameContact")}
            fullWidth
            required
            inputProps={{ maxLength: 100 }}
            autoComplete="off"
            label="Apellidos"
            //helperText="Error"
            margin="dense"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFielddocumentContact}
            name="documentContact"
            value={values.documentContact}
            onChange={handleChange("documentContact")}
            fullWidth
            required
            inputProps={{ maxLength: 12 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Cédula"
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFieldEmail}
            name="email"
            value={values.email}
            onChange={handleChange("email")}
            /* onInput={(e) => {
               handleValidate(e.target.value);
            }}*/
            fullWidth
            required
            inputProps={{ maxLength: 150 }}
            autoComplete="off"
            label="Correo electrónico"
            margin="dense"
            //   helperText={mensaje_validate}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFieldphoneContact}
            name="phoneContact"
            value={values.phoneContact}
            onChange={handleChange("phoneContact")}
            fullWidth
            required
            inputProps={{ maxLength: 12 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Teléfono"
            margin="dense"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <LoadGender
            callback={getResponseGender}
            value={values.genderContactData}
            error={values.errorGenderContact}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
}

function step2Form(
  values,
  handleChange,
  getResponseCityRecycler,
  getResponseActorType,
  handleChangeDateStartRecycler,
  classes
) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10 }}>
          <div className={classes.titleCardSub2}>
            <Business className={classes.iconSubTitle} />
            DATOS DEL RECICLADOR, EMPRESA U ORGANIZACIÓN DE RECICLAJE
          </div>
          <Divider variant="fullWidth" style={{ marginBottom: "4%" }} />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="nameRecycler"
            value={values.nameRecycler}
            error={values.errorFieldnameRecycler}
            onChange={handleChange("nameRecycler")}
            fullWidth
            required
            inputProps={{ maxLength: 100 }}
            autoComplete="off"
            label="Reciclador / organización / empresa"
            helperText="Nombre"
            margin="dense"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name="descriptionRecycler"
            value={values.descriptionRecycler}
            error={values.errorFielddescriptionRecycler}
            onChange={handleChange("descriptionRecycler")}
            fullWidth
            required
            inputProps={{ maxLength: 150 }}
            autoComplete="off"
            label="Breve descripción"
            //helperText="Error"
            margin="dense"
            //rows="3"
            multiline
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <LoadCiudades
            callback={getResponseCityRecycler}
            value={values.cityRecyclerData}
            error={values.errorFieldCity}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            name="addressRecycler"
            value={values.addressRecycler}
            error={values.errorFieldaddressRecycler}
            onChange={handleChange("addressRecycler")}
            fullWidth
            required
            inputProps={{ maxLength: 150 }}
            autoComplete="off"
            label="Dirección del proyecto"
            //helperText="Error"
            margin="dense"
            //rows="3"
            multiline
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFieldWomanNumber}
            name="womanNumber"
            value={values.womanNumber}
            onChange={handleChange("womanNumber")}
            fullWidth
            required
            inputProps={{ maxLength: 12 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Mujeres que trabajan en el proyecto"
            margin="dense"
            helperText="Cantidad"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            error={values.errorFieldMenNumber}
            name="menNumber"
            value={values.menNumber}
            onChange={handleChange("menNumber")}
            fullWidth
            required
            inputProps={{ maxLength: 12 }}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}
            autoComplete="off"
            label="Hombres que trabajan en el proyecto"
            margin="dense"
            helperText="Cantidad"
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <LoadRecyclerType
            callback={getResponseActorType}
            value={values.actorTypeData}
            error={values.errorFieldactorType}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
            <KeyboardDatePicker
              // disableToolbar
              //  disabled={disabled}
              error={values.errorDateStartRecycler}
              variant="inline"
              format="dd/MM/yyyy"
              margin="dense"
              openTo="year"
              autoOk={true}
              id="dateStartRecycler"
              autoComplete="off"
              label="Fecha de inicio del proyecto en Ecuador"
              value={values.dateStartRecycler}
              onChange={handleChangeDateStartRecycler}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              style={{ width: "100%" }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </Fragment>
  );
}

function step3Form(
  values,
  icon,
  checkedIcon,
  classes,
  loader,
  textCatSelectWaste,
  changeOrganicWaste
) {
  return (
    <Fragment>
      <Grid container spacing={2} className={classes.containerStyle}>
        <Grid item xs={12} sm={12} style={{ marginTop: 10, marginBottom: 20 }}>
          <div className={classes.titleCardSub2}>RECURSOS RESIDUALES</div>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.titleCardSub2}>
            <LibraryAddCheck className={classes.iconSubTitle} />
            YO NECESITO
          </div>
          {loader ? (
            <Fragment>
              <FormLabel component="legend">Desechos orgánicos</FormLabel>
              <center>
                <Skeleton width={300} height={40} />
              </center>
            </Fragment>
          ) : (
            <Fragment>
              <Autocomplete
                multiple
                size="small"
                id="organicWaste"
                options={values.organicWaste}
                value={values.organicWasteDataN}
                disableCloseOnSelect
                getOptionLabel={(option) => option.detailName}
                onChange={changeOrganicWaste}
                getOptionSelected={(option, value) => {
                  return option.detailName === value.detailName;
                }}
                renderOption={(option, { selected }) => (
                  <Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                      color="primary"
                    />
                    {option.detailName}
                  </Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={values.errorOrganicWasteN}
                    name="organicWaste"
                    //  required
                    label="Desechos orgánicos"
                    margin="dense"
                  />
                )}
              />
              <List>
                {values.organicWasteDataNViews.map((items, i) => {
                  return (
                    <ListItem
                      key={items}
                      role={undefined}
                      dense
                      className={classes.listCatalogSelect}
                    >
                      <ListItemIcon>
                        <HtmlTooltip title={textCatSelectWaste(items)}>
                          <Pageview style={{ cursor: "pointer" }} />
                        </HtmlTooltip>
                      </ListItemIcon>

                      <ListItemText
                        id={items}
                        primary={`${items.detailName}`}
                      />
                    </ListItem>
                  );
                })}
              </List>
            </Fragment>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}
